import { carpoolServiceToUiAdapter, carpoolUiToServiceAdapter } from '../../../adapters';
import { parkingSplitApi } from '../apiBase';
export var carpoolApi = parkingSplitApi.injectEndpoints({
    overrideExisting: true,
    endpoints: function (builder) { return ({
        getCarpool: builder.query({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrl = _a.carpoolApiCreateGroupUrl, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrl, "/").concat(registrationId),
                    method: 'GET',
                });
            },
            transformResponse: function (response) {
                return response && carpoolServiceToUiAdapter(response);
            },
        }),
        postCarpool: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrl = _a.carpoolApiCreateGroupUrl, requestData = _a.requestData;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrl),
                    method: 'POST',
                    body: carpoolUiToServiceAdapter(requestData),
                    invalidates: ['Posts'],
                });
            },
        }),
        updateCarpool: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrl = _a.carpoolApiCreateGroupUrl, requestData = _a.requestData, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrl, "/").concat(registrationId),
                    method: 'PATCH',
                    body: carpoolUiToServiceAdapter(requestData),
                });
            },
        }),
        deleteCarpool: builder.mutation({
            query: function (_a) {
                var carpoolApiBaseUrl = _a.carpoolApiBaseUrl, regionId = _a.regionId, carpoolApiCreateGroupUrl = _a.carpoolApiCreateGroupUrl, registrationId = _a.registrationId;
                return ({
                    url: "".concat(carpoolApiBaseUrl).concat(regionId).concat(carpoolApiCreateGroupUrl, "/").concat(registrationId),
                    method: 'DELETE',
                });
            },
        }),
    }); },
});
export var reducerPath = carpoolApi.reducerPath, useGetCarpoolQuery = carpoolApi.useGetCarpoolQuery, usePostCarpoolMutation = carpoolApi.usePostCarpoolMutation, useUpdateCarpoolMutation = carpoolApi.useUpdateCarpoolMutation, useDeleteCarpoolMutation = carpoolApi.useDeleteCarpoolMutation;
